module.exports = __webpack_public_path__ + "static/media/18ECA22.c6f5adf9.jpg";